import { render } from "./DataCard.vue?vue&type=template&id=108a2afc&scoped=true&ts=true"
import script from "./DataCard.vue?vue&type=script&lang=ts"
export * from "./DataCard.vue?vue&type=script&lang=ts"

import "./DataCard.vue?vue&type=style&index=0&id=108a2afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108a2afc"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QDialog,QSpace,QBtn});qInstall(script, 'directives', {ClosePopup});
